import { FileUploadSetting } from 'backend';
import { getFileUploadSubmissionSessions } from 'fetcher';
import { useEffect } from 'react';
import {
  FILE_UPLOAD_SESSION_STATE_TYPE,
  updateFileUploadSessionState,
  useFileUpload,
  useUpdateFileUploadSessionStateDispatch,
  FileUploadSessionState,
} from 'store';

type UseDispatchSubmissionSessionStatePayload = {
  sessionType: FileUploadSessionState['type'];
  setting?: FileUploadSetting;
};

const useDispatchSubmissionSessionState = ({
  sessionType,
  setting,
}: UseDispatchSubmissionSessionStatePayload) => {
  const dispatch = useUpdateFileUploadSessionStateDispatch();

  const dispatchSubmissionSessionState = async (): Promise<void> => {
    if (
      setting == null ||
      sessionType !== FILE_UPLOAD_SESSION_STATE_TYPE.notReady
    ) {
      return;
    }
    try {
      const submissionSessions = await getFileUploadSubmissionSessions({
        apiRoot: setting.submissionApiOrigin,
        formSrn: setting.formSrn,
      });
      const {
        submissionId,
        expiration,
        token,
        accessKeyId,
        secretAccessKey,
        mediaFileStore,
      } = submissionSessions.submissionSession;

      dispatch(
        updateFileUploadSessionState({
          type: FILE_UPLOAD_SESSION_STATE_TYPE.ready,
          submissionSession: {
            submissionId,
            expiration,
            token,
            accessKeyId,
            secretAccessKey,
            mediaFileStore,
          },
        })
      );
    } catch (_) {
      dispatch(
        updateFileUploadSessionState({
          type: FILE_UPLOAD_SESSION_STATE_TYPE.error,
          errorMessage: setting.errorMessages.ERROR,
        })
      );
    }
  };

  return dispatchSubmissionSessionState;
};

export const useFileUploadInitialize = (): void => {
  const { session, setting } = useFileUpload();
  const dispatch = useDispatchSubmissionSessionState({
    sessionType: session.type,
    setting,
  });

  useEffect(() => {
    dispatch();
  }, [dispatch]);
};
